module.exports = __webpack_public_path__ + "static/wohlfuehlen-a7fcc5a052ec254336deddc0d285244e.png";